// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './SectionItem.less';

/**
 * `SectionItem` component. Used as row in `Section` component.
 */
const SectionItem = ({
    baseClassName,
    className,
    children,
    title,
    actions,
    vertical,
    ...props
}, { verticalSection }) => (
    <div
        className={classNames(baseClassName, {
            [`${baseClassName}--actions`]: actions,
            [`${baseClassName}--vertical`]: vertical === null ? verticalSection : vertical,
        }, className)}
        {...props}
    >
        {title === null ? null : <div className={`${baseClassName}__title`}>{title}</div>}
        <div className={`${baseClassName}__value`}>
            {children}
        </div>
    </div>
);

SectionItem.propTypes = {
    /**
     * Content of the `SectionItem`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
    /**
     * Title of the section item.
     */
    title: PropTypes.node,
    /**
     * Is this section item contains actions? If it so than there should be extra whitespaces.
     */
    actions: PropTypes.bool,
    /**
     * @ignore
     */
    vertical: PropTypes.bool,
};

SectionItem.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}section-item`,
    title: null,
    actions: false,
    vertical: null,
};

SectionItem.contextTypes = {
    verticalSection: PropTypes.bool,
};

export default SectionItem;



// WEBPACK FOOTER //
// ./components/Section/SectionItem.js